export const baseApiURL = () => {
  return process.env.REACT_APP_APILINK;
};
export const media = () => {
  return process.env.REACT_APP_MEDIA_LINK;
};
